export default [
    {
        path: '/course/curriculum',
        name: 'CourseCurriculumList',
        component: () => import('@/pages/course/curriculum/List.vue'),
        meta: {
            title: '我的课程',
            requireAuth: true,
            authority: 'course:curriculum'
        }
    },
    {
        path: '/course/curriculum/add',
        name: 'CourseCurriculumAdd',
        component: () => import('@/pages/course/curriculum/Add.vue'),
        meta: {
            title: '新建课程',
            requireAuth: true,
            authority: 'course:curriculum'
        }
    },
    {
        path: '/course/curriculum/edit',
        name: 'CourseCurriculumEdit',
        component: () => import('@/pages/course/curriculum/Edit.vue'),
        meta: {
            title: '编辑课程',
            requireAuth: true,
            authority: 'course:curriculum'
        }
    },
    {
        path: '/course/curriculum/detail',
        name: 'CourseCurriculumDetail',
        component: () => import('@/pages/course/curriculum/detail/Detail.vue'),
        meta: {
            title: '课程详情',
            requireAuth: true,
            authority: 'course:curriculum'
        },
        redirect: '/course/curriculum/detail/hour',
        children: [
            {
                path: 'hour',
                name: 'CourseCurriculumDetailHour',
                component: () => import('@/pages/course/curriculum/detail/hour/List.vue'),
                meta: {
                    title: '课时管理',
                    requireAuth: true,
                    authority: 'course:curriculum'
                }
            },
            {
                path: 'document',
                name: 'CourseCurriculumDetailDocument',
                component: () => import('@/pages/course/curriculum/detail/document/List.vue'),
                meta: {
                    title: '学习资料',
                    requireAuth: true,
                    authority: 'course:curriculum'
                }
            },
            {
                path: 'report',
                name: 'CourseCurriculumDetailReport',
                component: () => import('@/pages/course/curriculum/detail/report/List.vue'),
                meta: {
                    title: '学情报告',
                    requireAuth: true,
                    authority: 'course:curriculum'
                }
            },
        ]
    },
    {
        path: '/course/curriculum/detail/hour/add',
        name: 'CourseCurriculumDetailHourRedact',
        component: () => import('@/pages/course/curriculum/detail/hour/Redact.vue'),
        meta: {
            title: '新建课时',
            requireAuth: true,
            authority: 'course:curriculum'
        }
    },
    {
        path: '/course/curriculum/detail/hour/edit',
        name: 'CourseCurriculumDetailHourRedact',
        component: () => import('@/pages/course/curriculum/detail/hour/Redact.vue'),
        meta: {
            title: '编辑课时',
            requireAuth: true,
            authority: 'course:curriculum'
        }
    },
    {
        path: '/course/curriculum/detail/document/add',
        name: 'CourseCurriculumDetailDocumentRedact',
        component: () => import('@/pages/course/curriculum/detail/document/Redact.vue'),
        meta: {
            title: '新建资料',
            requireAuth: true,
            authority: 'course:curriculum'
        }
    },
    {
        path: '/course/curriculum/detail/document/edit',
        name: 'CourseCurriculumDetailDocumentRedact',
        component: () => import('@/pages/course/curriculum/detail/document/Redact.vue'),
        meta: {
            title: '编辑资料',
            requireAuth: true,
            authority: 'course:curriculum'
        }
    },
    {
        path: '/course/curriculum/detail/document/study',
        name: 'CourseCurriculumDetailDocumentStudy',
        component: () => import('@/pages/course/curriculum/detail/document/Study.vue'),
        meta: {
            title: '学习资料',
            requireAuth: true,
            authority: 'course:curriculum'
        }
    }
]


// WEBPACK FOOTER //
// ./src/router/module/course.js